import styled from 'styled-components';

export const Container = styled.div`
  .ant-form-item,
  .marginCol {
    margin-bottom: 16px;
  }
`;
